
export default function () {

  const {
    trackAddToCartBundleBuilder,
    trackClickItemBundleBuilder,
    trackViewBundleBuilder,
  } = useGtmEvents();
  const callAddToCart = (sku: string) => {

    trackAddToCartBundleBuilder({ sku });
  
  };
  const callClickBundleItem = (sku: string) => {

    trackClickItemBundleBuilder({ sku });
  
  };
  const callViewEvent = (sku: string) => {

    trackViewBundleBuilder({ sku });
  
  };

  return { callAddToCart, callClickBundleItem, callViewEvent };

}
